import React from 'react'
import { Link } from 'react-router-dom'
import { TeamData } from '../data'

export default function TeamOne() {
  return (
        <div className="row">
            {TeamData.map((item,index)=>{
                return(
                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
                        <div className="mt-4 pt-2">
                            <div className="team position-relative d-block text-center">
                                <div className="image position-relative d-block overflow-hidden">
                                    <img src={item.image} className="img-fluid rounded" alt=""/>
                                    <div className="overlay rounded"></div>
                                </div>
                                <div className="content py-2 member-position bg-white border-bottom overflow-hidden rounded d-inline-block">
                                    <h4 className="title mb-0">{item.name}</h4>
                                    <small className="text-muted">{item.position}</small>
                                </div>
                                <ul className="list-unstyled team-social social-icon mb-0">
                                    {item.social.map((el,index)=>{
                                        return(
                                            <li className="list-inline-item m-x-2" key={index}><Link to="#" className="rounded"><i className={el}></i></Link></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                )
            })}

            <div className="col-12 text-center mt-4 pt-4">
                <div className="alert alert-light alert-pills mt-4 mb-0" role="alert">
                    <span className="badge bg-danger rounded-pill"> Jobs </span>
                    <span className="alert-content ms-2"> We Are Hiring <Link to="#" className="text-primary">Send your CV / Resume</Link> <i className="mdi mdi-briefcase-outline"></i></span>
                </div>
            </div>
        </div>
  )
}
